<template>
  <div
    v-if="visible"
    class="fixed inset-0 z-30 flex items-center justify-center bg-transparent"
  >
    <div
      class="fixed top-0 z-10 h-full w-full bg-dark-gray bg-opacity-50"
      @click="$emit('click-outside-modal')"
    />
    <div class="relative z-10 scroll-auto">
      <div class="flex justify-center px-4">
        <div class="tablet relative rounded bg-white p-8">
          <!-- Content -->
          <img
            class="absolute right-4 top-4 h-4 w-4 cursor-pointer"
            src="@/assets/close-icon.svg"
            alt="close icon"
            @click="handleCloseModal()"
          />
          <h3 class="text-left text-2xl text-dark-gray">
            Add New ELD Provider
          </h3>
          <p class="mb-4 mt-1 text-left text-body-color">
            Select the ELD provider you would like to add.
          </p>

          <autocomplete-search
            placeholder="Search ELD Provider"
            label="ELD Provider"
            name="eld_provider_autocomplete"
            :items="availableElds"
            :handle-on-change="handleEldSearch"
            :handle-select="handleSelectEldProvider"
          />

          <br />
          <br />

          <!-- <span class="w-full md:flex md:w-full md:flex-col md:gap-2 md:flex-row-reverse">
                        <button-main 
                             :loadingSpinner="true"
                            :disabled="isAddEldsDisabled"
                            @click="handleSubmit"
                            class="mt-3 md:mt-0"> 
                            Add ELD Provider</button-main>
                            
                        <button-main variant="secondary" @click="handleCloseModal()"
                            class="mt-2 md:mt-0 sm:">Cancel</button-main>
                    </span> -->
          <form
            novalidate="novalidate"
            @submit.prevent="handleSubmit"
          >
            <button-main
              :loading-spinner="isLoading"
              :disabled="isAddEldsDisabled"
              type="submit"
              value="Add ELD Provider"
              class="mb-3 md:mt-0"
            />

            <button-main
              variant="secondary"
              class="sm: mt-2 md:mt-0"
              @click="handleCloseModal()"
            >
              Cancel
            </button-main>
          </form>
          <!-- End content -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Autocomplete from '@/components/Autocomplete.vue';
import ButtonMain from '@/components/Button.vue';

export default {
  name: 'Modal',
  components: { ButtonMain, 'autocomplete-search': Autocomplete },
  props: {
    visible: Boolean,
  },
  emits: ['click-outside-modal'],
  data() {
    return {
      isAddEldsDisabled: true,
      eldProvider: null,
      isLoading: false,
      selectOptions: [
        'Select Contact Type',
        'After Hours',
        'Emergency',
        'Owner',
      ],
    };
  },
  computed: {
    availableElds() {
      return this.$store.state.integrations?.truckerTools?.availableElds;
    },
    channelId() {
      return this.$store.state.integrations?.truckerTools?.channelId;
    },
  },
  methods: {
    handleSelectEldProvider(eldProvider) {
      if (eldProvider === 'Select ELD Provider') {
        return;
      }
      this.eldProvider = eldProvider;
      this.isAddEldsDisabled = false;
    },
    handleCloseModal() {
      this.$emit('close');
      this.isAddEldsDisabled = true;
      this.eldProvider = null;
    },
    handleEldSearch(search) {
      if (search.length === 0 && !this.isAddEldsDisabled) {
        this.isAddEldsDisabled = true;
      }
    },
    async handleSubmit() {
      this.isLoading = true;
      const res = await this.$store.dispatch(
        'integrations/getTruckerSignUpURL',
        this.eldProvider?.code
      );
      const url = res?.data?.url;
      const urlWithChannelId = url.includes('?')
        ? `${url}&channel_id=${this.channelId}`
        : `${url}?channel_id=${this.channelId}`;
      if (url) {
        window.open(urlWithChannelId, '_blank');
      }
      this.isLoading = false;
      this.handleCloseModal();
    },
  },
};
</script>
